<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<a @click="routeTo('/users')"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></a
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button class="jmiBtn btnLg green" @click="save()">
								{{ editUser.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/users')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img
												src="/assets/images/teleflow-logo-black.png"
												alt="TeleFlow Logo"
												width="200"
											/>
										</div>
									</div>
								</div>

								<div v-if="!loading">
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Personal Information</h3>
									</div>
									<div
										class="mx-auto mb-2 flex w-full flex-col flex-wrap items-center px-2 md:mb-5 md:flex-row"
									>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Name</label>
												<p>
													{{
														editUser.id.indexOf('@clients') > -1
															? 'API User'
															: editUser.auth0?.name
													}}
												</p>
											</div>
										</div>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Email</label>
												<p>
													{{
														editUser.id.indexOf('@clients') > -1
															? editUser.id
															: editUser.auth0?.email
													}}
												</p>
											</div>
										</div>
									</div>
									<div
										class="mx-auto mb-2 flex w-full flex-col flex-wrap items-center px-2 md:mb-5 md:flex-row"
									>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Last IP</label>
												<p>{{ editUser.auth0?.last_ip }}</p>
											</div>
										</div>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Provider</label>
												<p>{{ userProvider }}</p>
											</div>
										</div>
									</div>
									<div
										class="mx-auto mb-2 flex w-full flex-col flex-wrap items-center px-2 md:mb-5 md:flex-row"
									>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Last Login</label>
												<p>{{ $global.dateTimeFormat(editUser.auth0?.last_login) }}</p>
											</div>
										</div>
										<div class="w-full md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Login Count</label>
												<p>{{ editUser.auth0?.logins_count }}</p>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Settings</h3>
									</div>
									<div
										v-if="!editUser.accounts?.length && !editUser.tenants?.length"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<searchable-dropdown
											v-model="editUser.reseller"
											label="Reseller"
											:options="resellerOptions"
											:multi-select="false"
											placeholder="-- Select a reseller --"
										/>
									</div>
									<div
										v-if="!editUser.accounts?.length && !editUser.reseller"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<template v-if="$global.isMobile">
											<label class="textGrey">Tenant(s):</label>
											<select
												class="formGroupInput"
												multiple
												:value="editUser.tenants"
												@change="handleTenantsChange"
											>
												<option
													v-for="option in tenantOptions"
													:key="option.value"
													:value="option.value"
												>
													{{ option.label }}
												</option>
											</select>
										</template>
										<searchable-dropdown
											v-else
											v-model="editUser.tenants"
											label="Tenant(s)"
											:options="tenantOptions"
											:multi-select="true"
											placeholder="-- Select tenants --"
										/>
									</div>
									<div
										v-if="!editUser.tenants?.length && !editUser.reseller"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<template v-if="$global.isMobile">
											<label class="textGrey">Account(s):</label>
											<select
												class="formGroupInput"
												multiple
												:value="editUser.accounts"
												@change="handleAccountsChange"
											>
												<option
													v-for="option in accountOptions"
													:key="option.value"
													:value="option.value"
												>
													{{ option.label }}
												</option>
											</select>
										</template>
										<searchable-dropdown
											v-else
											v-model="editUser.accounts"
											label="Account(s)"
											:options="accountOptions"
											:multi-select="true"
											placeholder="-- Select accounts --"
										/>
									</div>
									<div class="row margin-b20">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button class="jmiBtn btnLg green" @click="save()">Save</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/users')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import usersApi from '../scripts/users/users.api.js'
import { router } from '../router'
import resellersApi from '../scripts/resellers/resellers.api'
import accountsApi from '@/scripts/accounts/accounts.api'
import SearchableDropdown from '../components/common/SearchableDropdown.vue'

export default {
	components: {
		SearchableDropdown
	},
	inject: ['user', 'userRoles', 'modalProp1', 'modalProp2', 'tenants'],
	data() {
		return {
			editUser: {
				tenants: [],
				reseller: null,
				id: ''
			},
			loading: true,
			resellers: [],
			accounts: []
		}
	},

	computed: {
		tenantsWithoutResellers() {
			return this.tenants.map((t) => {
				delete t.reseller
				return t
			})
		},
		accountsWithoutTenants() {
			return this.accounts.map((a) => {
				delete a.tenant
				return a
			})
		},
		userProvider() {
			if (this.editUser.auth0?.identities[0]?.provider === 'google-oauth2') return 'Google'
			if (this.editUser.auth0?.identities[0]?.provider === 'windowslive') return 'Microsoft'
			if (this.editUser.auth0?.identities[0]?.provider === 'linkedin') return 'LinkedIn'
			if (this.editUser.auth0?.identities[0]?.provider === 'auth0') return 'Username / Password'
			else return 'Other'
		},
		resellerOptions() {
			return this.resellers.map((reseller) => ({
				value: reseller,
				label: reseller.companyName
			}))
		},
		tenantOptions() {
			return this.tenantsWithoutResellers.map((tenant) => ({
				value: tenant,
				label: tenant.companyName
			}))
		},
		accountOptions() {
			return this.accountsWithoutTenants.map((account) => ({
				value: account,
				label: account.name
			}))
		}
	},

	async created() {
		try {
			const userResult = usersApi.getById(this.$route.params.id)
			const accountsResult = accountsApi.getAll({ limit: 2500 })
			const resellerResult = resellersApi.getAll()

			this.accounts = (await accountsResult).data?.results
			this.editUser = (await userResult).data
			this.resellers = (await resellerResult).data?.results

			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading users',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/')
			})
			console.error(e)
		}
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			usersApi
				.update(this.editUser)
				.then((u) => {
					this.routeTo('/users')
				})
				.catch(console.error)
		},
		handleResellerChange(value) {
			this.editUser.reseller = value
		},
		handleTenantsChange(value) {
			this.editUser.tenants = value
		},
		handleAccountsChange(value) {
			this.editUser.accounts = value
		}
	}
}
</script>
